import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import { alpha, useTheme } from '@mui/material/styles';

/**
 * Definitions of allied organisations.  Substitute the `logo` field
 * with imports to real logo images when available.  For now we
 * display the first letter of each organisation inside an avatar.
 */
const allies = [
  {
    name: 'Comercializadora Indígena Wayuu',
    description: 'Promueve el comercio justo con identidad ancestral.',
    logo: null,
  },
  {
    name: 'Zona Franca La Guajira',
    description: 'Alianzas logísticas desde la frontera venezolana.',
    logo: null,
  },
  {
    name: 'Grupo Aduanal Nacional',
    description: 'Red de agentes certificados a nivel nacional.',
    logo: null,
  },
];

/**
 * Allies section listing strategic partners.  Cards include a subtle
 * hover animation similar to the Services section.  The section title
 * is highlighted with a soft background.
 */
const Allies = () => {
  const theme = useTheme();
    const pearl = '#FFFFFF';
  const pearlGlass = alpha(pearl, 0.72);
  return (
      <Box id="aliados" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
            variant="h3"
            component="h2"
                    sx={{
                display: 'block',
                px: 2,
                pt: 0.5,
                pb: 1.5,
                bgcolor: pearlGlass,
                color: 'text.primary',
                backdropFilter: 'blur(6px)',
                borderRadius: 1,
                fontWeight: 700,
              }}
          >
            Aliados Comerciales
          </Typography>
        </Box>
        <Typography
          variant="subtitle1"
          sx={{
            maxWidth: 700,
            mx: 'auto',
            mb: 6,
            textAlign: 'center',
            color: 'text.secondary',
          }}
        >
          Trabajamos de la mano con aliados estratégicos que complementan y fortalecen nuestras capacidades logísticas y aduaneras:
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {allies.map((ally) => (
            <Grid item xs={12} sm={6} md={4} key={ally.name}>
              <Card
                sx={{
                  p: 3,
                  textAlign: 'center',
                  borderRadius: 3,
                  height: '100%',
                  boxShadow: 1,
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
              >
                {ally.logo ? (
                  <Box
                    component="img"
                    src={ally.logo}
                    alt={ally.name}
                    sx={{ height: 48, mb: 2 }}
                  />
                ) : (
                  <Avatar
                    sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText, mb: 2 }}
                  >
                    {ally.name.charAt(0)}
                  </Avatar>
                )}
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {ally.name}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {ally.description}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Allies;